import { render } from "./TableHeaderCell.vue?vue&type=template&id=5a45e6b6"
import script from "./TableHeaderCell.vue?vue&type=script&lang=js"
export * from "./TableHeaderCell.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__